import React from 'react'

import {
    ErrorBox,
    FormHeader,
    FormSubtitle,
    FormTitle,
    Panel,
    StateBox,
    Table,
    TableWrapper,
} from '../style'
import { useHistoryAuditTab } from './useHistoryAuditTab'

const HistoryAuditTab = () => {
    const {
        audit,
        auditLoading,
        auditError,
        actionLabel,
        formatDate,
        describeChanges,
    } = useHistoryAuditTab()

    return (
        <Panel>
            <FormHeader>
                <div>
                    <FormTitle>Журнал изменений</FormTitle>
                    <FormSubtitle>
                        Кто и когда менял расписание: добавление, изменение и удаление занятий
                    </FormSubtitle>
                </div>
            </FormHeader>

            {auditError && <ErrorBox>{auditError}</ErrorBox>}

            {auditLoading ? (
                <StateBox>Загрузка...</StateBox>
            ) : audit.length === 0 ? (
                <StateBox>Изменений пока нет</StateBox>
            ) : (
                <TableWrapper>
                    <Table>
                        <thead>
                            <tr>
                                <th>Дата</th>
                                <th>Пользователь</th>
                                <th>Действие</th>
                                <th>Занятие</th>
                                <th>Что изменилось</th>
                            </tr>
                        </thead>
                        <tbody>
                            {audit.map((entry) => (
                                <tr key={entry.id}>
                                    <td>{formatDate(entry.performed_at, true)}</td>
                                    <td>{entry.performed_by || '—'}</td>
                                    <td>{actionLabel[entry.action] || entry.action}</td>
                                    <td>#{entry.record_id ?? '—'}</td>
                                    <td>{describeChanges(entry)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </TableWrapper>
            )}
        </Panel>
    )
}

export default HistoryAuditTab
